import axiosInstance from './axios-instance'
import Vue from 'vue'

const request = (config) => {
  const resolveCodes = config.resolveCodes ?? [200]
  const errorTipType = config.errorTipType ?? 'dialog'
  const isShowErrorTip = config.isShowErrorTip ?? true
  const isRejectError = config.isRejectError ?? true
  config.headers = {
    requestFrom: 'h5'
  }

  return new Promise(async (resolve, reject) => {
    try {
      const res = await axiosInstance(config)
      if (resolveCodes === 'all' || resolveCodes.includes(res.code)) {
        resolve(res)
      } else {
        const errMsg = res.msg ?? '网络繁忙，请稍后再试'
        isShowErrorTip ? showErrorTip(errorTipType, errMsg, 'ERROR' + (res.code ?? '')) : ''
        isRejectError ? reject(new Error(errMsg)) : ''
      }

    } catch (error) {
      isShowErrorTip ? showErrorTip(errorTipType, error.message, '系统繁忙，请稍后再试') : ''
      isRejectError ? reject(error) : ''
    }
  })
}

function showErrorTip(errorTipType, content, title) {
  if (errorTipType === 'dialog') {
    Vue.prototype.$dialog.alert({
      title,
      message: content,
    })
  } else if (errorTipType === 'toast') {
    Vue.prototype.$toast.fail(content)
  }
}


export default request
